import { useUI } from '@components/ui'
import cn from 'clsx'
interface Props {
  displayText?: string
  classname?: string
}
const CalculatorButton = ({ displayText, classname }: Props) => {
  const { setSidebarView, openSidebar } = useUI()
  const showCalculatorModal = () => {
    setSidebarView('PAINT_CALCULATOR_MODAL_VIEW')
    openSidebar()
  }
  return (
    <>
      <button
        className={cn(
          'label-bold flex items-center justify-between outline-none focus:outline-none',
          {
            classname,
          }
        )}
        aria-label="Calculator Modal"
        onClick={showCalculatorModal}
      >
        {displayText && (
          <div className="body-2 text-brand-dark-grey underline">
            {displayText}
          </div>
        )}
      </button>
    </>
  )
}
export default CalculatorButton
